import { render, staticRenderFns } from "./EditButton.vue?vue&type=template&id=64407d8a&"
import script from "./EditButton.vue?vue&type=script&lang=js&"
export * from "./EditButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports